<ng-container *transloco="let t">
  <mat-card *ngIf="aggregated$ | async as aggr" class="mat-elevation-z4">
    <mat-card-content>
      <div class="row w-100 text-center">
        <div class="col ml-2 completed">
          <div class="title">{{t('aggregated.fields.sessionsCompleted')}}</div>
          <div class="value">{{aggr.sessionsCompleted}}</div>
        </div>
        <div class="col uncompleted">
          <div class="title">{{t('aggregated.fields.sessionsUncompleted')}}</div>
          <div class="value">{{aggr.sessionsUncompleted}}</div>
        </div>
        <div class="col completed-today">
          <div class="title">{{t('aggregated.fields.sessionsCompletedToday')}}</div>
          <div class="value">{{aggr.sessionsCompletedToday}}</div>
        </div>
        <div class="col uncompleted-today">
          <div class="title">{{t('aggregated.fields.sessionsUncompletedToday')}}</div>
          <div class="value">{{aggr.sessionsUncompletedToday}}</div>
        </div>
        <div class="col failed">
          <div class="title">{{t('aggregated.fields.sessionsWithFailOutcome')}}</div>
          <div class="value">{{aggr.sessionsWithFailOutcome}}</div>
        </div>
        <div class="col active-users">
          <div class="title">{{t('aggregated.fields.activeUsers')}}</div>
          <div class="value">{{aggr.activeUsers}}</div>
        </div>
        <div class="col refresh">
          <a title="{{t('buttons.refresh')}}" (click)="refresh()">
            <mat-icon><i class="material-icons">refresh</i></mat-icon>
          </a>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
